import { SaveButton } from "@/components/button/SaveEditCancel/SaveButton";
import { InputAndLabelPasswordBox } from "@/components/input/InputAndLabelPasswordBox/InputAndLabelPasswordBox";
import { observer } from "mobx-react-lite";
import { useForm } from "react-hook-form";
import styles from "./FormEditPassword.module.css";
import { FieldsForEdit, User, UserResponse } from "@/types/User.interface";
import { CancelButton } from "@/components/button/SaveEditCancel/CancelButton";

export interface FormValues {
  current_password: string;
  new_password: string;
  again_new_password: string;
}

interface EditPasswordData {
  user: UserResponse | User;
  returnDataForSetPassword: (credentials: FieldsForEdit) => void;
  modalHide?: () => void;
}

export const FormEditPassword = observer(
  ({ user, returnDataForSetPassword, modalHide }: EditPasswordData) => {
    const {
      register,
      handleSubmit,
      setValue,
      watch,
      formState: { errors },
    } = useForm<FormValues>({
      defaultValues: {
        current_password: "",
        new_password: "",
        again_new_password: "",
      },
      mode: "onSubmit",
    });
    const password = watch("new_password");

    const onSubmit = (data: FormValues) => {
      const credentials = {
        id: user.id,
        current_password: data.current_password,
        new_password: data.new_password,
      };
      defaultValues();
      returnDataForSetPassword(credentials);
    };

    const defaultValues = () => {
      setValue("current_password", "");
      setValue("new_password", "");
      setValue("again_new_password", "");
    };

    const close = () => {
      modalHide?.();
      defaultValues();
    };

    return (
      <form onSubmit={handleSubmit(onSubmit)}>
        <div>
          <InputAndLabelPasswordBox
            props={{
              ...register("current_password", {
                required: "Укажите текущий пароль",
              }),
              placeholder: "",
            }}
            idAndForHTML="currentPassword"
            labelText="Текущий пароль"
          />
          <InputAndLabelPasswordBox
            props={{
              ...register("new_password", {
                required: "Укажите новый пароль",
              }),
              placeholder: "",
            }}
            idAndForHTML="newPassword"
            labelText="Новый пароль"
          />
          <InputAndLabelPasswordBox
            props={{
              ...register("again_new_password", {
                required: "Повторите новый пароль",
                validate: (value) => value === password || "Пароли не совпадают",
              }),
              placeholder: "",
            }}
            idAndForHTML="again_new_password"
            labelText="Повторите новый пароль"
          />

          <div className={styles.buttons}>
            <SaveButton onSubmit={handleSubmit(onSubmit)} type="submit">
              Сохранить
            </SaveButton>
            <CancelButton type="button" onClick={close}>
              Отменить
            </CancelButton>
          </div>
        </div>
        <div>
          <div className={styles.errors}>
            {Object.values(errors).map((error, i) => (
              <p key={`${error.message}-${i}`}>{error.message}</p>
            ))}
          </div>
        </div>
      </form>
    );
  }
);
